import { DrawerLayout } from '@/components/layouts/DrawerLayout.jsx';
import {useNavigate, useParams} from "react-router-dom";
import {useGetUserQuery, useUpdateUserMutation} from '../api';
import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {FormControl, FormLabel, Input, Stack} from "@mui/joy";
import {FormButtons} from "@/components/FormButtons.jsx";
import {roles, updateUserSchema} from "@/features/users/schema.jsx";
import {FormSelect} from "@/components/forms/FormSelect.jsx";

export function UpdateUserPage() {
  const { householdId, id } = useParams();
  const { isFetching, data } = useGetUserQuery({ householdId, id });

  const [saveUser, saveResult] = useUpdateUserMutation();

  async function save(data) {
    await saveUser({ householdId, id, data });
  }

  return (
    <DrawerLayout title="Update User">
      {isFetching ? 'Loading...' : <UpdateUserForm data={data.data} save={save} saveResult={saveResult} />}
    </DrawerLayout>
  );
}

function UpdateUserForm({ data, save, saveResult }) {
  const { householdId } = useParams();
  const navigate = useNavigate();

  const form = useForm({
    defaultValues: data,
    resolver: yupResolver(updateUserSchema)
  });

  async function onSubmit(data) {
    await save(data);
    navigate(`/h/${householdId}/users`);
  }
  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Stack
          spacing={4}
          sx={{
            display: 'flex',
            pt: 2,
            pb: 3,
          }}
        >
          <Stack spacing={2}>
            <FormControl>
              <FormLabel>Email</FormLabel>
              <Input value={data.email} disabled />
            </FormControl>
            <FormSelect name="role" label="Role" options={roles}/>
          </Stack>
        </Stack>
        <FormButtons isSaving={saveResult.isLoading} />
      </form >
    </FormProvider>
  );
}
